export function asError(e: unknown, message = 'Unknown error'): Error {
  return e instanceof Error ? e : new Error(message, { cause: e });
}

export function normalizeErrorMessage(error: unknown): string {
  if (typeof error === 'string') {
    return error;
  }
  if (
    error !== null &&
    typeof error === 'object' &&
    'error' in error &&
    typeof (error as { error: string }).error === 'string'
  ) {
    return (error as { error: string }).error;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Unknown error';
}
